// apps/web/src/lib/painel/home/abas.ts — Fase 17.8, Plano 04 (D-01, D-02, D-03, D-04).
//
// Quais abas de perfil a sessão vê e qual abre primeiro. Funções puras: o gate é o mesmo da 16.1 (`blocosVisiveis`,
// por permissão de ação, nunca por nome de Role) e as abas são ergonomia; a autorização real é o 403 de cada endpoint.
import { ID_PERFIS_HOME, type IdBlocoPainel, type PerfilHome } from '@pieltec/contracts';
import { blocosVisiveis } from '../blocos';

/** Perfil (aba) de cada bloco da 16.1; a Visão geral é a aba Diretoria (D-04). */
export const PERFIL_DO_BLOCO: Readonly<Record<IdBlocoPainel, PerfilHome>> = {
  pcp: 'pcp',
  qualidade: 'qualidade',
  almoxarifado: 'almoxarifado',
  compras: 'compras',
  faturamento: 'faturamento',
  'visao-geral': 'diretoria',
};

/** Bloco legado da 16.1 de cada aba (fallback enquanto a aba não foi migrada). */
export const BLOCO_DO_PERFIL: Readonly<Record<PerfilHome, IdBlocoPainel>> = {
  pcp: 'pcp',
  qualidade: 'qualidade',
  almoxarifado: 'almoxarifado',
  compras: 'compras',
  faturamento: 'faturamento',
  diretoria: 'visao-geral',
};

export const ROTULO_ABA: Readonly<Record<PerfilHome, string>> = {
  pcp: 'PCP',
  qualidade: 'Qualidade',
  almoxarifado: 'Almoxarifado',
  compras: 'Compras',
  faturamento: 'Faturamento',
  diretoria: 'Diretoria',
};

/** Abas permitidas, sempre na ordem PCP, Qualidade, Almoxarifado, Compras, Faturamento, Diretoria. */
export function abasPermitidas(permissoes: readonly string[]): PerfilHome[] {
  const perfis = new Set(blocosVisiveis(permissoes).map((id) => PERFIL_DO_BLOCO[id]));
  return ID_PERFIS_HOME.filter((perfil) => perfis.has(perfil));
}

export interface EntradaAbaInicial {
  readonly permitidas: readonly PerfilHome[];
  readonly permissoes: readonly string[];
  /** Aba lembrada no cookie; só vale se ainda for permitida. */
  readonly salva: string | null;
}

/**
 * Aba que abre primeiro: a última usada (se ainda permitida); senão, Admin (permissão administrativa `users:manage`, não o
 * nome do Role) abre em Diretoria quando ela é permitida (D-03); senão a primeira permitida; sem abas, null.
 */
export function abaInicial({ permitidas, permissoes, salva }: EntradaAbaInicial): PerfilHome | null {
  const lembrada = permitidas.find((perfil) => perfil === salva);
  if (lembrada !== undefined) return lembrada;
  if (permissoes.includes('users:manage') && permitidas.includes('diretoria')) return 'diretoria';
  return permitidas[0] ?? null;
}
